// @ts-nocheck
/* eslint-disable */
import React from 'react';
import mapContext from '../contexts/map-context';
import { ActionTypes } from '../contexts/reducers/map-reducer';
import { getServices } from '../utils/search';
import type { Dealer } from '../models/dealer';
import useSearchByGeoLocation from './useSearchByGeoLocation';
import trackingContext from '../contexts/tracking-context';
import { trackSearchByGeolocationQuery } from '../utils/trackingUtils';
import { getRadiusInKm } from '../utils/distance';
import { getActiveFilters } from '../utils/activeFilters';

export default function useResultsByGeoLocation() {
  const { trackingService: tService } = trackingContext.useTrackingState();
  const dispatch = mapContext.useMapDispatch();
  const {
    searchGeoLocation,
    userSelectedFilters,
    preselectedFilters,
    searchRadius,
    locale,
    intlSearchEnabled,
    userGeolocation,
    distanceUnit,
    searchText,
  } = mapContext.useMapState();

  const activeFilters = getActiveFilters(preselectedFilters, userSelectedFilters);

  const searchRadiusInKm = getRadiusInKm(searchRadius, distanceUnit);

  const {
    loading,
    error,
    dealersResult,
    searchRadius: searchRadiusResult,
  } = useSearchByGeoLocation(
    searchRadiusInKm,
    searchGeoLocation.lat,
    searchGeoLocation.lng,
    intlSearchEnabled ? undefined : locale.countryCode,
    activeFilters,
    userGeolocation ? userGeolocation.lat : undefined,
    userGeolocation ? userGeolocation.lng : undefined,
  );

  const dispatchSuccessfulQueries = (dealers: Dealer[]) => {
    dispatch({
      type: ActionTypes.setLoading,
      payload: false,
    });
    dispatch({
      type: ActionTypes.setSearchError,
      payload: null,
    });
    dispatch({
      type: ActionTypes.setResults,
      payload: { dealers, services: getServices(dealers) },
    });
    dispatch({
      type: ActionTypes.setSelectedPartner,
      payload: {
        tenant: dealers[0] ? dealers[0].country : undefined,
        kvpsid: dealers[0] ? dealers[0].kvpsId : undefined,
      },
    });
    dispatch({ type: ActionTypes.setShowRadius, payload: true });
    dispatch({
      type: ActionTypes.setSearchRadiusExtended,
      payload: (searchRadiusResult && searchRadiusInKm < searchRadiusResult) || false,
    });
    trackSearchByGeolocationQuery(
      tService,
      searchText,
      dealersResult ? dealersResult.length : 0,
      activeFilters,
      dealersResult || [],
    );
  };

  React.useEffect(() => {
    if (error) {
      dispatch({
        type: ActionTypes.setSearchError,
        payload: error,
      });
    }
  }, [error]);

  React.useEffect(() => {
    if (loading) {
      dispatch({
        type: ActionTypes.setLoading,
        payload: true,
      });
      dispatch({ type: ActionTypes.setSearchRadiusExtended, payload: false });
    }
  }, [loading]);

  React.useEffect(() => {
    if (dealersResult && !loading) {
      dispatchSuccessfulQueries(dealersResult);
    }
  }, [dealersResult, loading]);
}
